import { getStorageValue } from "../service/shared.service";
const DateFormating :any = {
  US: {
    formating: 'M0/d0/0000',
    PlaceHolder: 'MM/DD/YYYY',
    specialCharacters: ['/']
  },
  CA: {
    formating: '0000-M0-d0',
    PlaceHolder: 'YYYY-MM-DD',
    specialCharacters: ['-']
  },
  GB: {
    formating: 'd0/M0/0000',
    PlaceHolder: 'DD/MM/YYYY',
    specialCharacters: ['/']
  },
  AU: {
    formating: 'd0-M0-0000',
    PlaceHolder: 'DD-MM-YYYY',
    specialCharacters: ['-']
  },
  NZ: {
    formating: 'd0/M0/0000',
    PlaceHolder: 'DD/MM/YYYY',
    specialCharacters: ['/']
  },
  FR: {
    formating: 'd0/M0/0000',
    PlaceHolder: 'DD/MM/YYYY',
    specialCharacters: ['/']
  },
  DE: {
    formating: 'd0.M0.0000',
    PlaceHolder: 'DD.MM.YYYY',
    specialCharacters: ['.']
  },
  IT: {
    formating: 'd0/M0/0000',
    PlaceHolder: 'DD/MM/YYYY',
    specialCharacters: ['/']
  },
  JP: {
    formating: '0000/M0/d0',
    PlaceHolder: 'YYYY/MM/DD',
    specialCharacters: ['/']
  },
  PL: {
    formating: 'd0.M0.0000',
    PlaceHolder: 'DD.MM.YYYY',
    specialCharacters: ['.']
  },
  ES: {
    formating: 'd0-M0-0000',
    PlaceHolder: 'DD-MM-YYYY',
    specialCharacters: ['-']
  },
};

export  const  formatDate = (date: any) =>{
  const dates = new Date(date); // Parse the date string
  const year = dates.getFullYear(); // Get the year (YYYY)
  let month = (dates.getMonth() + 1).toString().padStart(2, '0'); // Get the month (MM)
  let day = dates.getDate().toString().padStart(2, '0'); // Get the day (DD)

  return `${year}-${month}-${day}`;
}


export const formatDate2 = (date: any) => {
  const dates = new Date(date); // Parse the date string
  const year = dates.getFullYear(); // Get the year (YYYY)
  let month = (dates.getMonth() + 1).toString().padStart(2, '0'); // Get the month (MM)
  let day = dates.getDate().toString().padStart(2, '0'); // Get the day (DD)

  const countryData: any = getStorageValue("partnerData");
  const countryCode = countryData && countryData.country_currency_info &&  countryData.country_currency_info.country.country_code;  
  console.log(countryCode,"countryCode");
  

  // Get the date format and special characters for the country code
  const { formating} = DateFormating[countryCode] || DateFormating['US'];

  // Format the date string according to the country format
  let formattedDate = formating.replace('0000', year.toString()).replace('M0', month).replace('d0', day);

  return formattedDate;
};

